import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';


const CallExpiryFormulas = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main" className='warrant-sensitivity Common_warrent  call_examples'>
                <div id="maintable" style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav" className='first_table'>
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}} />
                                            <div className="prevname " style={{textAlign: 'left'}}>Last trading day</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>Single share calls and puts at expiry</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Call expiry Formula</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}} />
                                            <div className="nextname " style={{textAlign: 'right'}}>Call example</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                            {/*<link rel="stylesheet" href="css/common.css"/>*/}
                            <title>Cash settlement amount for single share Warrants at expiry</title>
                            <style dangerouslySetInnerHTML={{__html: "        \n            .contentbox h2{\n font-family: inherit; \n                font-size:18px;\n                color:#FFDA44;\n                text-align:center;\n            }\n            .formulabox table{\n/*                font-size:22px;*/\n            }\n        " }} />
                            <div className="contentbox">
                                <p>All structured warrants in Bursa Malaysia are currently cash settled; investors do not take delivery of the physical shares. Instead, holders of warrants with value at expiry shall receive a cash settlement amount within seven business days from the expiry date.</p>
                                <p>To calculate the cash settlement amount of single share warrants, a settlement price of the underlying share is used. This settlement price can be calculated using one of the following methods:</p>
                                <p>1. The 5-day volume weighted average price (VWAP) of the underlying share prior to the expiry date; or</p>
                                <p>2. The average closing price (AVP) of the underlying share for the 5 market days prior to the expiry date; or</p>
                                <p>3. The closing price of the underlying share on the market day prior to the expiry date.</p>
                                <p>Macquarie uses the AVP method in determining the Settlement Price for single share warrants at expiry. </p>
                                <h2 className="title">Formula to calculate value of call warrant at expiry</h2>
                                <div className="formulaholder">
                                <div className="formulabox">
                                    <div className="leqt">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td className="hltxt" style={{height: '39px'}}>    
                                                Value at Expiry =
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>   
                                    <div className="reqt">
                                    <table className="fraction">
                                        <tbody>
                                        <tr><td>(Settlement Price - Exercise Price)</td></tr>
                                        <tr><td className="upper_line">Exercise Ratio</td></tr>
                                        </tbody>  
                                    </table>
                                    </div>
                                </div>
                                </div>
                                <p>The same formula above applies for warrants over foreign shares, but its value at expiry shall be converted to MYR using the applicable foreign exchange rate at expiry.</p>
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
               <div className='copyright_sec'>
               Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
               </div>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            >
                                 <Link to="/edu/single-share-calls/call-example">
                        <span className="prevname ">  Call example</span>
                      </Link>
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/single-share-calls/call-example">
                            <div className="next right" />
                            </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/single-share-calls/last-trading-day">
                            <div className="prev left" />
                            </Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            >
                                 <Link to="/edu/single-share-calls/last-trading-day">
                        <span className="prevname "> Last trading day</span>
                      </Link>
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
            {/* <div className="dbtn dbtn-seminarbtn">
            <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
        </div> */}
        <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
      );
}
export default CallExpiryFormulas;